    import React from "react";


function About() {
    return (
        <section className="about-part">
            <div className="container">
                <div className="row align-items-center">

                    {/* LEFT CONTENT */}
                    <div className="col-lg-6 col-md-12">
                        <div className="about-content">
                            <h2>About Us</h2>
                            <p>
                                Welcome to <strong>Paraksh</strong> — your trusted destination
                                for quality products at the best prices. We are committed to
                                delivering a smooth, secure, and enjoyable shopping experience.
                            </p>

                            <p>
                                Our mission is to connect customers with reliable products,
                                fast delivery, and excellent customer support. We believe in
                                quality, transparency, and customer satisfaction.
                            </p>

                            <ul className="about-list">
                                <li>✔ High quality products</li>
                                <li>✔ Secure payments</li>
                                <li>✔ Fast delivery</li>
                                <li>✔ 24/7 customer support</li>
                            </ul>
                        </div>
                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="col-lg-6 col-md-12">
                        <div className="about-image">
                            {/* <img src={aboutImg} alt="About us" /> */}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default About;
